export class WalletError extends Error {
  code: string;
  
  constructor(message: string, code: string) {
    super(message);
    this.name = 'WalletError';
    this.code = code;
  }
}

export class WalletConnectionError extends WalletError {
  constructor(message: string) {
    super(message, 'CONNECTION_ERROR');
    this.name = 'WalletConnectionError';
  }
}

export class WalletNotFoundError extends WalletError {
  constructor(walletType: string) {
    super(`${walletType} wallet not found. Please install the wallet.`, 'WALLET_NOT_FOUND');
    this.name = 'WalletNotFoundError';
  }
}

export class ChainNotSupportedError extends WalletError {
  constructor(chainId: string) {
    super(`Chain ${chainId} is not supported`, 'CHAIN_NOT_SUPPORTED');
    this.name = 'ChainNotSupportedError';
  }
}

export class UserRejectedError extends WalletError {
  constructor(message = 'User rejected the request') {
    super(message, 'USER_REJECTED');
    this.name = 'UserRejectedError';
  }
}

export class TransactionError extends WalletError {
  constructor(message: string) {
    super(message, 'TRANSACTION_ERROR');
    this.name = 'TransactionError';
  }
}